"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAudio = exports.isHTML = exports.isImage = exports.is3DModel = exports.isVideo = exports.encodeSVGDataString = exports.SVGDataPrefix = exports.mediaIsLandscape = void 0;
/**
 * In a browser environment, this function will return true if the media is landscape.
 * In a node environment, this function will break.
 */
const mediaIsLandscape = (src) => {
    const img = new Image();
    img.src = src;
    const width = img.width;
    let height = img.height;
    height = height + height; // Double the height to get best
    if (width > height) {
        return true;
    }
    return false;
};
exports.mediaIsLandscape = mediaIsLandscape;
/**
 * @dev adapted from https://yoksel.github.io/url-encoder/
 */
const SVGSymbols = /[\r\n%#()<>?[\\\]^`{|}]/g;
exports.SVGDataPrefix = 'data:image/svg+xml';
/**
 * encodes the svg symbols returned in the data string so that `data`
 * can be rendered as an `img` tag's src value
 */
function encodeSVGDataString(data) {
    let encoded = data;
    const hasPrefix = data.substring(0, exports.SVGDataPrefix.length) === exports.SVGDataPrefix;
    if (hasPrefix) {
        // disregard the prefix start;
        encoded = encoded.substring(exports.SVGDataPrefix.length);
    }
    encoded = encoded.replace(/>\s{1,}</g, `><`);
    encoded = encoded.replace(/\s{2,}/g, ` `);
    // Using encodeURIComponent() as replacement function for specific symbols in SVG data
    return `${hasPrefix ? exports.SVGDataPrefix : ''}${encoded.replace(SVGSymbols, encodeURIComponent)}`;
}
exports.encodeSVGDataString = encodeSVGDataString;
/**
 * Regexes for sniffing content type from mimetype
 * @ref https://www.digipres.org/formats/mime-types/
 */
exports.isVideo = new RegExp(/(mp4|mov|avi|webm|flv|wmv)/, 'i');
exports.is3DModel = new RegExp(/(obj|fbx|glb|gltf|gltf+json)/, 'i');
exports.isImage = new RegExp(/(gif|png|jpg|jpeg|svg|bmp|tif|tiff|raw)/, 'i');
exports.isHTML = new RegExp(/(html)/, 'i');
exports.isAudio = new RegExp(/(mp3|wav|aac|ogg|m4a|flac)/, 'i');
//# sourceMappingURL=media.js.map